import React from 'react';
import { FlameIcon, UsersIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  return <section className="w-full border-y-[3px] border-dashed border-amber bg-danger px-6 py-12 text-center text-white sm:px-10" data-id="element-194" data-mp="2nhn8pwqdu5al">
      <div className="mx-auto max-w-2xl" data-id="element-195" data-mp="2sapsjd5cy0dl">
        <p className="flex items-center justify-center gap-2 text-xl font-bold sm:text-2xl" data-id="element-196" data-mp="2wb8l59f2ragu">
          <FlameIcon className="h-6 w-6" aria-hidden="true" data-id="element-197" data-mp="319tc0i8fshsm" /> ¡Oferta por 24 horas solamente!
        </p>
        <p className="mt-4 text-xl font-bold text-amber sm:text-2xl" data-id="element-198" data-mp="369frkybqma4l">
          Antes: <span className="line-through" data-id="element-199" data-mp="367boujpkrh5w">€45</span> | Ahora: €19 (58% descuento)
        </p>

        <div className="mt-7 flex items-center justify-center gap-3 font-mono text-3xl font-bold sm:text-4xl" role="timer" aria-live="off" data-id="element-200" data-mp="3b66di2a83zxx">
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-201" data-mp="1gtg9usu1zcdc">{hours}</div>
          <span aria-hidden="true" data-id="element-202" data-mp="27eq1xw8k5mpx">:</span>
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-203" data-mp="27frlkp3n3hj9">{minutes}</div>
          <span aria-hidden="true" data-id="element-204" data-mp="22nhp0q80rj80">:</span>
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-205" data-mp="22mexqh6sberk">{seconds}</div>
        </div>
        <p className="mt-2 text-xs uppercase tracking-wide text-white/80" data-id="element-206" data-mp="1xpon49dr1bdj">Horas : Minutos : Segundos</p>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm" data-id="element-207" data-mp="1srepls4jxyor">
          <span className="relative flex h-2 w-2" data-id="element-208" data-mp="2qcj3ov7g3qlq">
            <span className="absolute inline-flex h-full w-full animate-pulse-dot rounded-full bg-amber" data-id="element-209" data-mp="2qb7z4t66eetk" />
          </span>
          <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-210" data-mp="2gf4qr5kqdjy6" /> 47 personas mirando esto ahora
        </p>

        <a href="#comprar" className="mt-7 inline-flex w-full items-center justify-center rounded-lg bg-amber px-8 py-5 text-lg font-bold text-danger transition-colors duration-150 ease-out hover:bg-amber-dark hover:text-white sm:w-auto sm:min-w-[420px]" data-id="element-211" data-mp="2cecf65odz2yq">
          Quiero acceso ahora — 19€
        </a>
      </div>
    </section>;
}